import { render, staticRenderFns } from "./FlashSaleStepGeneralInfo.vue?vue&type=template&id=7d630435&scoped=true&"
import script from "./FlashSaleStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./FlashSaleStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleStepGeneralInfo.vue?vue&type=style&index=0&id=7d630435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d630435",
  null
  
)

export default component.exports